import { lazyLoadPage } from 'common/utils/lazyLoad';

import { ErrorPage as ErrorPageComponent } from './ErrorPage/ErrorPage';

export const ErrorPage = ErrorPageComponent;

export const FinancePage = lazyLoadPage(() =>
  import(/* webpackChunkName: "FinancePage" */ './FinancePage/FinancePage').then((r) => r.FinancePage),
);

export const FastPayPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "FastPayPage" */ './FastPayPage/FastPayPage').then((r) => r.FastPayPage),
);

export const JobBoardPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "JobBoardPage" */ './JobBoardPage/JobBoardPage').then((r) => r.JobBoardPage),
);

export const JobOfferPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "OfferPage" */ './JobOfferPage/JobOfferPage').then((r) => r.JobOfferPage),
);

export const RfqsOfferPage = lazyLoadPage((/* webpackChunkName: "RfqsOfferPage" */) =>
  import('./RfqsOfferPage').then((r) => r.RfqsOfferPage),);

export const OrderPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "OrderPage" */ './OrderPage/OrderPage').then((r) => r.OrderPage),
);

export const OrdersPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "OrdersPage" */ './OrdersPage/OrdersPage').then((r) => r.OrdersPage),
);

export const SupportPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "SupportPage" */ './SupportPage').then((r) => r.SupportPage),
);

export const ProfileDetailsPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "ProfileDetailsPage" */ './ProfilePage').then((r) => r.ProfilePage),
);

export const ConfirmEmailPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "ConfirmEmailPage" */ './ConfirmEmailPage').then((r) => r.ConfirmEmailPage),
);

export const InitResetPasswordPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "InitResetPasswordPage" */ './InitResetPasswordPage').then(
    (r) => r.InitResetPasswordPage,
  ),
);

export const ResetPasswordPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "ResetPasswordPage" */ './ResetPasswordPage').then((r) => r.ResetPasswordPage),
);

export const OnboardingPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "OnboardingPage" */ './OnboardingPage').then((r) => r.OnboardingPage),
);

export const SgTermsPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "SgTermsPage" */ './SgTermsPage').then((r) => r.SgTermsPage),
);

export const SignInPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "SignInPage" */ './SignInPage').then((r) => r.SignInPage),
);

export const SignUpPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "SignUpPage" */ './SignUpPage').then((r) => r.SignUpPage),
);

export const UnsubscribeEmailPage = lazyLoadPage(() =>
  import(/* webpackChunkName: "UnsubscribeEmailPage" */ './UnsubscribeEmailPage').then((r) => r.UnsubscribeEmailPage),
);
